var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9505 7.22138C23.9631 7.17362 25.9314 7.80221 27.5265 9.00206M21.9613 1.5C22.4772 1.62115 22.9636 1.84055 23.3926 2.14563C23.8215 2.45071 24.1847 2.83547 24.4612 3.27788C24.7377 3.72028 24.9222 4.21164 25.004 4.7238C25.0858 5.23596 25.0634 5.75886 24.9381 6.26255L24.6792 7.31621M2.10557 28.6107C6.12321 27.2778 9.66453 24.8458 12.3085 21.6038C13.9963 19.1257 15.5098 16.5382 16.8383 13.8594C17.2805 12.9849 17.9168 11.6889 18.4022 10.9303C21.7564 5.66196 29.9964 9.65533 27.6883 15.4399C27.1602 16.6928 26.5025 17.8896 25.7254 19.0118C20.6239 26.1557 11.2839 32.0035 2.09478 30.0437C1.92529 30.0038 1.77445 29.9094 1.66656 29.7756C1.55867 29.6418 1.5 29.4764 1.5 29.3061C1.5 29.1358 1.55867 28.9704 1.66656 28.8366C1.77445 28.7028 1.92529 28.6084 2.09478 28.5685L2.10557 28.6107Z",
    stroke: "#9E1A30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpicy);
export default __webpack_public_path__ + "static/media/Spicy.66a00e212541d3868c429da00b185ae0.svg";
export { ForwardRef as ReactComponent };